import { Box, Typography } from "@material-ui/core"
import { Dispatch, SetStateAction } from "react"
import styled from "styled-components"
import Calendar from "../Calendar"
import HeadingText from "../Texts/HeadingText"

const StyledBox = styled(Box)<{ $pastTimeError: string }>`
  margin-top: 30px;
  position: relative;
  > div {
    margin-top: 20px;
  }
  .react-datepicker-wrapper {
    border: ${(p) =>
      p.$pastTimeError ? "1px solid rgba(215, 2, 2, 0.5)" : "none"} !important;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 20px;
  }
`

const StyledError = styled(Typography).attrs({ variant: "body1" })`
  color: #d70202;
  font-size: 18px;
  line-height: 1;
  text-align: right;
  position: absolute;
  bottom: -20px;
`

type GiftCardStartTimeProps = {
  setScheduleStartTime: Dispatch<SetStateAction<Date | string>>
  scheduleStartTime: Date | string
  scheduleError: string
  setScheduleEndTime: Dispatch<SetStateAction<Date | string>>
  pastTimeError: string
}
const GiftCardStartTime = ({
  setScheduleStartTime,
  scheduleStartTime,
  scheduleError,
  setScheduleEndTime,
  pastTimeError,
}: GiftCardStartTimeProps) => {
  const handleTimeChange = () => {
    setScheduleEndTime(null)
  }

  const getAvailableDates = (date) => {
    const currentDate = new Date()
    const thresholdHour = 23
    const thresholdMinute = 45
    if (
      currentDate.getHours() === thresholdHour &&
      currentDate.getMinutes() > thresholdMinute
    )
      return new Date(date) > new Date()
    return true
  }

  return (
    <StyledBox $pastTimeError={pastTimeError}>
      <HeadingText text="הגיפטקארד הראשון ישלח בתאריך:" />
      <Calendar
        date={scheduleStartTime}
        setDate={setScheduleStartTime}
        type="startTime"
        handleTimeChange={handleTimeChange}
        setEndTime={setScheduleEndTime}
        filterDate={getAvailableDates}
      />
      {scheduleError && !scheduleStartTime && (
        <StyledError>{scheduleError}</StyledError>
      )}
    </StyledBox>
  )
}

export default GiftCardStartTime
